import Vue from "vue";
import App from "./App.vue";
import "./plugins/axios";
import "./plugins/directives";
import vuetify from "./plugins/vuetify";
import router from "./router";
import { pinia } from "./store";
import "@mdi/font/css/materialdesignicons.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  pinia,
  render: (h) => h(App),
}).$mount("#app");
